export function ackPopup(ackPopupIndex: number) {
  localStorage.setItem('ackPopupDate', new Date().toISOString());
  localStorage.setItem('ackPopupIndex', ackPopupIndex.toString());
}

export function getCurrentCardIndex() {
  const ackPopupIndex = localStorage.getItem('ackPopupIndex');
  return ackPopupIndex ? parseInt(ackPopupIndex) : -1; // start at -1 so that the first Popup is 0
}

export function shouldPopupCard() {
  const ackPopupDate = localStorage.getItem('ackPopupDate');
  if (!ackPopupDate) {
    return true;
  }
  const date = new Date(ackPopupDate);
  const today = new Date();
  const diff = Math.abs(today.getTime() - date.getTime());
  const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
  return diffDays > 7;
}
